// pack de modifications sur les freedatas sur retour de commit

import { FreeDataValue } from "@wizeoo/akm-message-lib";

// pour synchronisation de la matrice de cellule et des trios
export interface FreedataUpdatePack  {
    freedataCode: string; // code du FD cible
    // collections par types d'opération
    toRemoveFDV: Map<string, FreeDataValue>; // pour ne pas recréer un mort...
    toUpdateFDV: Map<string, FreeDataValue>;
    toCreateFDV: Map<string, FreeDataValue>;
  }